module.exports = __webpack_public_path__ + "static/media/awe-white-logo.397b4354.svg";